import type { HTMLAttributes } from 'react'
import { cx } from './cx'

export interface DividerProps extends Omit<HTMLAttributes<HTMLHRElement>, 'children'> {
  /** Margine di 16 ai lati, per allinearsi a icone e avatar. */
  inset?: boolean | undefined
}

/** Divisore M3: 1dp outline-variant, a tutta larghezza o inset. Decorativo. */
export function Divider({ inset, className, ...rest }: DividerProps) {
  return <hr {...rest} className={cx('md-divider', inset && 'md-divider--inset', className)} />
}
